module.exports = __webpack_public_path__ + "static/media/logo.4a0c4716.svg";